<a>
  <img alt="Logo" [src]="getImageUrl()" [ngClass]="{'h-50px': !logoUrlsToTry.length, 'h-75px': logoUrlsToTry.length}"
    (load)="onImageLoaded()" (error)="onImageError()" />
</a>